import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROGRESS_MASTER_FEATURE_KEY,
  ProgressMasterState,
  ProgressMasterPartialState,
  progressMasterAdapter,
} from './progress-master.reducer';
import { ProgressReportMasterDto } from '@cradua/data';

// Lookup the 'ProgressMaster' feature state managed by NgRx
export const getProgressMasterState = createFeatureSelector<
  ProgressMasterPartialState,
  ProgressMasterState
>(PROGRESS_MASTER_FEATURE_KEY);

const { selectAll, selectEntities } = progressMasterAdapter.getSelectors();

export const getProgressMasterLoaded = createSelector(
  getProgressMasterState,
  (state: ProgressMasterState) => state.loaded
);

export const getProgressMasterError = createSelector(
  getProgressMasterState,
  (state: ProgressMasterState) => state.error
);

export const loadingProgressMaster = createSelector(
  getProgressMasterState,
  (state: ProgressMasterState) => state.loaded
);

export const getAllProgressMaster = createSelector(
  getProgressMasterState,
  (state: ProgressMasterState) => selectAll(state)
);

export const getProgressMasterEntities = createSelector(
  getProgressMasterState,
  (state: ProgressMasterState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getProgressMasterState,
  (state: ProgressMasterState) => state.selectedProgressMasterId
);

export const getSelected = createSelector(
  getProgressMasterEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllProgressMaster,
  getSelectedId,
  (users: ProgressReportMasterDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.id.toLowerCase().includes(String(selectedId).toLowerCase()) ||
            user.ReportTitle.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.ProgressReportDescription.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
